module.exports = __webpack_public_path__ + "img/logo-heykama.d9aaf38d.png";